import React, { PureComponent } from "react";
import { Form, Select } from "antd";

import Section from "../../components/section/section";
import Panel from "../../components/panel/panel";

import "./loan.less";

class LenderSelector extends PureComponent {
  constructor() {
    super();
    this.handleLenderChange = this.handleLenderChange.bind(this);
  }

  handleLenderChange(lenderId) {
    this.props.setCurrentLender(lenderId);
    const params = {
      sort_field: "submission_date",
      sort_order: "desc",
      lender_id: lenderId,
      status: "approved",
      page: 1,
      size: 10,
    };
    const { fetchApplication } = this.props;
    fetchApplication(params);
  }

  render() {
    const { translate, lenders, fetchingLenderDetails } = this.props;
    const isDropdownDisabled = lenders.length === 0 || fetchingLenderDetails;
    const { Option } = Select;
    const formItemLayout = {
      labelCol: {
        sm: { span: 6 },
      },
      wrapperCol: {
        sm: { span: 6 },
      },
    };
    return (
      <Section className="lender-selector">
        <Panel>
          <span className="title">
            {translate("loanDetailPage.ovo_admin_heading_loan_details")}
          </span>
          <span className="sub-title">
            {translate("loanDetailPage.ovo_admin_sub_heading_lender_details")}
          </span>
          <Form {...formItemLayout}>
            <Form.Item
              label={translate("loanDetailPage.ovo_admin_label_lender_name")}
            >
              <Select
                placeholder={translate(
                  "loanDetailPage.ovo_admin_select_lender_dropdown_placeholder"
                )}
                disabled={isDropdownDisabled}
                onChange={this.handleLenderChange}
              >
                {lenders.map((lender) => (
                  <Option value={lender.lender_id}>{lender.lender_name}</Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Panel>
      </Section>
    );
  }
}

export default Form.create({})(LenderSelector);
